//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    me(): Observable<UserViewModel> {
        let url_ = this.baseUrl + "/api/Account/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserViewModel>;
        }));
    }

    protected processMe(response: HttpResponseBase): Observable<UserViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserViewModel>(null as any);
    }

    consentGiven(): Observable<void> {
        let url_ = this.baseUrl + "/api/Account/ConsentGiven";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConsentGiven(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConsentGiven(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConsentGiven(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    appInsightsConfig(): Observable<DynamicAppInsightsConfig> {
        let url_ = this.baseUrl + "/api/Account/insights-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppInsightsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppInsightsConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicAppInsightsConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicAppInsightsConfig>;
        }));
    }

    protected processAppInsightsConfig(response: HttpResponseBase): Observable<DynamicAppInsightsConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DynamicAppInsightsConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicAppInsightsConfig>(null as any);
    }

    getFeatures(): Observable<FeatureList> {
        let url_ = this.baseUrl + "/api/Account/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureList>;
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureList>(null as any);
    }
}

@Injectable()
export class AccumulatedGroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    index(): Observable<Group[]> {
        let url_ = this.baseUrl + "/api/AccumulatedGroup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Group[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Group[]>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<Group[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Group[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Group[]>(null as any);
    }

    create(createGroup: CreateGroupRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/AccumulatedGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createGroup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ApplicationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    customizations(): Observable<Customizations> {
        let url_ = this.baseUrl + "/api/Application/customizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomizations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomizations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customizations>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customizations>;
        }));
    }

    protected processCustomizations(response: HttpResponseBase): Observable<Customizations> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Customizations;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customizations>(null as any);
    }

    appInsightsConfig(): Observable<DynamicAppInsightsConfig> {
        let url_ = this.baseUrl + "/api/Application/insights-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAppInsightsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAppInsightsConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicAppInsightsConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicAppInsightsConfig>;
        }));
    }

    protected processAppInsightsConfig(response: HttpResponseBase): Observable<DynamicAppInsightsConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DynamicAppInsightsConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicAppInsightsConfig>(null as any);
    }

    getFeatures(): Observable<FeatureList> {
        let url_ = this.baseUrl + "/api/Application/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FeatureList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FeatureList>;
        }));
    }

    protected processGetFeatures(response: HttpResponseBase): Observable<FeatureList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FeatureList;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeatureList>(null as any);
    }
}

@Injectable()
export class ConnectionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(createSourceConnectionRequest: CreateSourceConnectionRequest): Observable<CreatedAtViewModel> {
        let url_ = this.baseUrl + "/api/Connection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createSourceConnectionRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedAtViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedAtViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatedAtViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedAtViewModel;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatedAtViewModel>(null as any);
    }

    delete(deleteSourceConnectionRequest: DeleteSourceConnectionRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Connection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteSourceConnectionRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    index(): Observable<SourceConnection[]> {
        let url_ = this.baseUrl + "/api/Connection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceConnection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceConnection[]>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<SourceConnection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceConnection[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceConnection[]>(null as any);
    }

    migrate(migrateSourceConnectionRequest: MigrateSourceConnectionRequest): Observable<CreatedAtViewModel> {
        let url_ = this.baseUrl + "/api/Connection/migrate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(migrateSourceConnectionRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMigrate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMigrate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedAtViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedAtViewModel>;
        }));
    }

    protected processMigrate(response: HttpResponseBase): Observable<CreatedAtViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedAtViewModel;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatedAtViewModel>(null as any);
    }

    get(id: string | null): Observable<SourceConnection> {
        let url_ = this.baseUrl + "/api/Connection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceConnection>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SourceConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceConnection>(null as any);
    }

    startSync(sourceSynchronisation: StartSourceSynchronisation): Observable<void> {
        let url_ = this.baseUrl + "/api/Connection/StartSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sourceSynchronisation);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartSync(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    loginForExport(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Connection/login-for-export/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginForExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginForExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginForExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    importGroups(id: string, expertMode?: boolean | null | undefined, formFile?: FileParameter | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Connection/{id}/import-groups?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (expertMode !== undefined && expertMode !== null)
            url_ += "expertMode=" + encodeURIComponent("" + expertMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processImportGroups(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }
}

@Injectable()
export class GroupService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    index(period?: string | null | undefined, prefix?: string | null | undefined, study?: string | null | undefined, studyGroup?: string | null | undefined, subjectId?: string | null | undefined, synced?: boolean | null | undefined, ignored?: boolean | null | undefined, disabled?: boolean | null | undefined, hasTeachers?: boolean | null | undefined, sourceId?: string | null | undefined): Observable<SourceGroup[]> {
        let url_ = this.baseUrl + "/api/Group?";
        if (period !== undefined && period !== null)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (prefix !== undefined && prefix !== null)
            url_ += "Prefix=" + encodeURIComponent("" + prefix) + "&";
        if (study !== undefined && study !== null)
            url_ += "Study=" + encodeURIComponent("" + study) + "&";
        if (studyGroup !== undefined && studyGroup !== null)
            url_ += "StudyGroup=" + encodeURIComponent("" + studyGroup) + "&";
        if (subjectId !== undefined && subjectId !== null)
            url_ += "SubjectId=" + encodeURIComponent("" + subjectId) + "&";
        if (synced !== undefined && synced !== null)
            url_ += "Synced=" + encodeURIComponent("" + synced) + "&";
        if (ignored !== undefined && ignored !== null)
            url_ += "Ignored=" + encodeURIComponent("" + ignored) + "&";
        if (disabled !== undefined && disabled !== null)
            url_ += "Disabled=" + encodeURIComponent("" + disabled) + "&";
        if (hasTeachers !== undefined && hasTeachers !== null)
            url_ += "HasTeachers=" + encodeURIComponent("" + hasTeachers) + "&";
        if (sourceId !== undefined && sourceId !== null)
            url_ += "SourceId=" + encodeURIComponent("" + sourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceGroup[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceGroup[]>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<SourceGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceGroup[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceGroup[]>(null as any);
    }

    get(id: string): Observable<SourceGroup> {
        let url_ = this.baseUrl + "/api/Group/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceGroup>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceGroup>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SourceGroup> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceGroup;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceGroup>(null as any);
    }

    syncGroups(syncGroupsRequest: SyncGroupsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/SyncGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncGroupsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSyncGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    ignoreGroups(ignoreGroupsRequest: IgnoreGroupsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/IgnoreGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ignoreGroupsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIgnoreGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIgnoreGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIgnoreGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    updateGroups(updateGroupsRequest: UpdateGroupsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/UpdateGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateGroupsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    bulkArchive(archiveTeamsRequest: BulkArchiveTeamsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/BulkArchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(archiveTeamsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    archive(archiveTeamsRequest: ArchiveTeamsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/Archive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(archiveTeamsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    delete(deleteGroupsRequest: DeleteGroupsRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/Group/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteGroupsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GroupSyncProfileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    list(): Observable<GroupSyncProfile[]> {
        let url_ = this.baseUrl + "/api/GroupSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupSyncProfile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupSyncProfile[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<GroupSyncProfile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupSyncProfile[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupSyncProfile[]>(null as any);
    }

    create(createGroupSyncProfileRequest: CreateGroupSyncProfileRequest): Observable<CreatedAtViewModel> {
        let url_ = this.baseUrl + "/api/GroupSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createGroupSyncProfileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedAtViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedAtViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatedAtViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedAtViewModel;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatedAtViewModel>(null as any);
    }

    patch(updateGroupSyncProfileRequest: UpdateGroupSyncProfileRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/GroupSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateGroupSyncProfileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    get(id: string | null): Observable<GroupSyncProfile> {
        let url_ = this.baseUrl + "/api/GroupSyncProfile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupSyncProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupSyncProfile>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GroupSyncProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupSyncProfile;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupSyncProfile>(null as any);
    }
}

@Injectable()
export class SchoolService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    index(select?: string | null | undefined): Observable<EducationSchool[]> {
        let url_ = this.baseUrl + "/api/School/list?";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationSchool[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationSchool[]>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<EducationSchool[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EducationSchool[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationSchool[]>(null as any);
    }

    addOrUpdate(addOrUpdateSchool: AddOrUpdateSchoolRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/School/addOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addOrUpdateSchool);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    list(): Observable<Tenant[]> {
        let url_ = this.baseUrl + "/api/admin/Tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenant[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenant[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<Tenant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tenant[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tenant[]>(null as any);
    }

    get(id: string): Observable<Tenant> {
        let url_ = this.baseUrl + "/api/admin/Tenant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenant>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenant>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Tenant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tenant;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tenant>(null as any);
    }

    create(createTenantRequest: CreateTenantRequest): Observable<CreatedAtViewModel> {
        let url_ = this.baseUrl + "/api/admin/Tenant/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTenantRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedAtViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedAtViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatedAtViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedAtViewModel;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatedAtViewModel>(null as any);
    }

    update(updateTenantRequest: UpdateTenantRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/admin/Tenant/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTenantRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TokenService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getToken(tenantId: string, tokenRequest: TokenRequest): Observable<TokenResponse> {
        let url_ = this.baseUrl + "/api/tenant/{tenantId}/token";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tokenRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TokenResponse>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<TokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TokenResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TokenResponse>(null as any);
    }
}

@Injectable()
export class UserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(id: string): Observable<SourceUser> {
        let url_ = this.baseUrl + "/api/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceUser>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceUser>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SourceUser> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceUser;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceUser>(null as any);
    }

    list(kind?: UserKind | null | undefined, synced?: boolean | null | undefined, disabled?: boolean | null | undefined, unavailable?: boolean | null | undefined, prefix?: string | null | undefined, source?: string | null | undefined, period?: string | null | undefined, mainClass?: string | null | undefined, study?: string | null | undefined, position?: string | null | undefined, positionId?: number | null | undefined, mainSubject?: string | null | undefined, mainSubjectCode?: string | null | undefined): Observable<SourceUser[]> {
        let url_ = this.baseUrl + "/api/User?";
        if (kind !== undefined && kind !== null)
            url_ += "Kind=" + encodeURIComponent("" + kind) + "&";
        if (synced !== undefined && synced !== null)
            url_ += "Synced=" + encodeURIComponent("" + synced) + "&";
        if (disabled !== undefined && disabled !== null)
            url_ += "Disabled=" + encodeURIComponent("" + disabled) + "&";
        if (unavailable !== undefined && unavailable !== null)
            url_ += "Unavailable=" + encodeURIComponent("" + unavailable) + "&";
        if (prefix !== undefined && prefix !== null)
            url_ += "Prefix=" + encodeURIComponent("" + prefix) + "&";
        if (source !== undefined && source !== null)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        if (period !== undefined && period !== null)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (mainClass !== undefined && mainClass !== null)
            url_ += "MainClass=" + encodeURIComponent("" + mainClass) + "&";
        if (study !== undefined && study !== null)
            url_ += "Study=" + encodeURIComponent("" + study) + "&";
        if (position !== undefined && position !== null)
            url_ += "Position=" + encodeURIComponent("" + position) + "&";
        if (positionId !== undefined && positionId !== null)
            url_ += "PositionId=" + encodeURIComponent("" + positionId) + "&";
        if (mainSubject !== undefined && mainSubject !== null)
            url_ += "MainSubject=" + encodeURIComponent("" + mainSubject) + "&";
        if (mainSubjectCode !== undefined && mainSubjectCode !== null)
            url_ += "MainSubjectCode=" + encodeURIComponent("" + mainSubjectCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SourceUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SourceUser[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<SourceUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SourceUser[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SourceUser[]>(null as any);
    }

    syncUsers(syncUsersRequest: SyncUsersRequest): Observable<CreateOrUpdateUsersResponse> {
        let url_ = this.baseUrl + "/api/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncUsersRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrUpdateUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrUpdateUsersResponse>;
        }));
    }

    protected processSyncUsers(response: HttpResponseBase): Observable<CreateOrUpdateUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOrUpdateUsersResponse;
            return _observableOf(result202);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOrUpdateUsersResponse>(null as any);
    }

    matchUser(matchUserRequest: MatchUserRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/User/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchUserRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatchUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatchUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMatchUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    checkUserGroups(syncUsersRequest: SyncUsersRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/User/check-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(syncUsersRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckUserGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    batch(batch: BatchUsersRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/User/Batch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(batch);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserSyncProfileService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    list(): Observable<UserSyncProfile[]> {
        let url_ = this.baseUrl + "/api/UserSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSyncProfile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSyncProfile[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<UserSyncProfile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSyncProfile[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSyncProfile[]>(null as any);
    }

    create(createUserSyncProfileRequest: CreateUserSyncProfileRequest): Observable<CreatedAtViewModel> {
        let url_ = this.baseUrl + "/api/UserSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createUserSyncProfileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatedAtViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatedAtViewModel>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreatedAtViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedAtViewModel;
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatedAtViewModel>(null as any);
    }

    patch(updateUserSyncProfileRequest: UpdateUserSyncProfileRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/UserSyncProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserSyncProfileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    get(id: string | null): Observable<UserSyncProfile> {
        let url_ = this.baseUrl + "/api/UserSyncProfile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSyncProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSyncProfile>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserSyncProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserSyncProfile;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserSyncProfile>(null as any);
    }
}

export interface UserViewModel {
    userId?: string | undefined;
    username?: string | undefined;
    tenantId?: string | undefined;
    tenant?: TenantViewModel | undefined;
    isAdmin?: boolean;
    isSupport?: boolean;
    isTeacher?: boolean;
    isTenantManager?: boolean;
}

export interface TenantViewModel {
    id?: string | undefined;
    isActivated?: boolean;
    name?: string | undefined;
    adminConsent?: boolean;
    adminConsentLink?: string | undefined;
    allowUserMatching?: boolean;
    allowUserUpdate?: boolean;
    userProfileExtensions?: boolean;
    userProfileFedLogin?: boolean;
}

export interface DynamicAppInsightsConfig {
    instrumentationKey?: string | undefined;
}

export interface FeatureList {
    ageGroups?: boolean;
    groupCombining?: boolean;
    groupHiding?: boolean;
    userAuthenticationMethods?: boolean;
    userLifecycle?: boolean;
}

export interface BaseEntity {
    id?: string | undefined;
    partition?: string | undefined;
    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
}

export interface Group extends BaseEntity {
    filter?: string | undefined;
    groups?: ChildGroup[] | undefined;
    groupMembers?: ResolvedGroupMember[] | undefined;
    azureGroupId?: string | undefined;
    displayName?: string | undefined;
    emailadres?: string | undefined;
    description?: string | undefined;
    teamTemplate?: string | undefined;
    syncStudents?: boolean;
    syncTeachers?: boolean;
    teachersAsMember?: boolean;
    alternativeOwner?: string | undefined;
}

export interface ChildGroup {
    externalId?: string | undefined;
}

export interface ResolvedGroupMember {
    externalId?: string | undefined;
    azureId?: string | undefined;
    role?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface CreateGroupRequest {
    filter?: string | undefined;
    groups?: string[] | undefined;
    azureGroupId?: string | undefined;
    displayName?: string | undefined;
    emailadres?: string | undefined;
    description?: string | undefined;
    teamTemplate?: string | undefined;
    syncStudents?: boolean;
    syncTeachers?: boolean;
    teachersAsMember?: boolean;
    alternativeOwner?: string | undefined;
}

export interface Customizations {
    name?: string | undefined;
    logo?: string | undefined;
    productLink?: string | undefined;
}

export interface CreatedAtViewModel {
    id?: string | undefined;
}

export interface CreateSourceConnectionRequest {
    sourceId?: string;
    connectionType?: SourceConnectionType;
    domain?: string | undefined;
    prefix?: string | undefined;
    brin?: string | undefined;
    credentials?: Credentials | undefined;
    connectionData?: { [key: string]: string; } | undefined;
    groupProfileId?: string;
    studentProfileId?: string;
    teacherProfileId?: string;
}

export enum SourceConnectionType {
    Unknown = "Unknown",
    Magister = "Magister",
    Azure = "Azure",
    Eduarte = "Eduarte",
}

export interface Credentials {
    username?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
}

export interface MigrateSourceConnectionRequest {
    sourceId?: string;
    period?: string | undefined;
    syncUntil?: Date;
    archiveExistingGroups?: boolean;
}

export interface DeleteSourceConnectionRequest {
    sourceId?: string;
}

export interface SourceConnection extends BaseEntity {
    connectionType?: SourceConnectionType;
    domain?: string | undefined;
    prefix?: string | undefined;
    connectionData?: { [key: string]: string; } | undefined;
    lastUpdate?: Date | undefined;
    groupProfileId?: string | undefined;
    studentProfileId?: string | undefined;
    teacherProfileId?: string | undefined;
    isValid?: boolean;
    numberOfStudents?: number | undefined;
    numberOfTeachers?: number | undefined;
    numberOfGroups?: number | undefined;
    lastImport?: Date | undefined;
}

export interface StartSourceSynchronisation {
    sourceConnectionId?: string | undefined;
    tryMatchAzureUsers?: boolean | undefined;
    checkAllGroupsAfterSync?: boolean | undefined;
}

export interface SourceGroup extends BaseEntity {
    source?: string | undefined;
    prefix?: string | undefined;
    externalId?: string | undefined;
    emailadres?: string | undefined;
    kind?: GroupKind | undefined;
    displayName?: string | undefined;
    period?: string | undefined;
    subject?: string | undefined;
    subjectId?: string | undefined;
    study?: string | undefined;
    yearOfStudy?: number | undefined;
    studyGroup?: string | undefined;
    teachers?: string[] | undefined;
    students?: string[] | undefined;
    azureObjectId?: string | undefined;
    synced?: boolean | undefined;
    ignore?: boolean | undefined;
    addTeachers?: boolean | undefined;
    removeTeachers?: boolean | undefined;
    addUsers?: boolean | undefined;
    removeUsers?: boolean | undefined;
    noLookup?: boolean | undefined;
    groupProfileId?: string | undefined;
    syncDisabled?: boolean | undefined;
    disabledReason?: string | undefined;
    archived?: boolean | undefined;
    lastUpdate?: Date | undefined;
}

export enum GroupKind {
    Unknown = "Unknown",
    Klas = "Klas",
    Vak = "Vak",
    Cluster = "Cluster",
}

export interface SyncGroupsRequest {
    groups?: string[] | undefined;
    alternativeOwnerId?: string | undefined;
    schoolId?: string | undefined;
    addTeachers?: boolean | undefined;
    removeTeachers?: boolean | undefined;
    addUsers?: boolean | undefined;
    removeUsers?: boolean | undefined;
    groupProfileId?: string | undefined;
}

export interface IgnoreGroupsRequest {
    groups?: string[] | undefined;
}

export interface UpdateGroupsRequest {
    sourceId?: string | undefined;
    groups?: string[] | undefined;
    syncDisabled?: boolean | undefined;
    disabledReason?: string | undefined;
    ignored?: boolean | undefined;
    synced?: boolean | undefined;
    addTeachers?: boolean | undefined;
    removeTeachers?: boolean | undefined;
    addUsers?: boolean | undefined;
    removeUsers?: boolean | undefined;
}

export interface BulkArchiveTeamsRequest {
    teamIds?: string | undefined;
    readOnlyForMembers?: boolean;
    hideInOutlook?: boolean;
    hideInAddressList?: boolean;
}

export interface ArchiveTeamsRequest {
    groups?: string[] | undefined;
    readOnlyForMembers?: boolean;
    hideInOutlook?: boolean;
    hideInAddressList?: boolean;
    newOwner?: string | undefined;
    replaceOwners?: boolean;
    replaceMembers?: boolean;
    keepCurrentOwnersAsMember?: boolean;
}

export interface DeleteGroupsRequest {
    groups?: string[] | undefined;
}

export interface SyncProfile extends BaseEntity {
    profileName?: string | undefined;
    defaultDomain?: string | undefined;
    displayNameFormat?: string | undefined;
    mailNicknameFormat?: string | undefined;
}

export interface GroupSyncProfile extends SyncProfile {
    classCodeFormat?: string | undefined;
    descriptionFormat?: string | undefined;
    courseNumberFormat?: string | undefined;
    courseDescriptionFormat?: string | undefined;
    courseNameFormat?: string | undefined;
    courseSubjectFormat?: string | undefined;
    termNameFormat?: string | undefined;
    defaultAlternativeOwner?: string | undefined;
    hideFromAddresslist?: boolean | undefined;
    groupVisibility?: string | undefined;
    teamTemplate?: string | undefined;
    contentQuery?: string | undefined;
}

export interface CreateGroupSyncProfileRequest {
    id?: string;
    profileName?: string | undefined;
    defaultDomain?: string | undefined;
    displayNameFormat?: string | undefined;
    mailNicknameFormat?: string | undefined;
    classCodeFormat?: string | undefined;
    descriptionFormat?: string | undefined;
    courseNumberFormat?: string | undefined;
    courseDescriptionFormat?: string | undefined;
    courseNameFormat?: string | undefined;
    courseSubjectFormat?: string | undefined;
    termNameFormat?: string | undefined;
    defaultAlternativeOwner?: string | undefined;
    hideFromAddresslist?: boolean | undefined;
    groupVisibility?: string | undefined;
    teamTemplate?: string | undefined;
    contentQuery?: string | undefined;
}

export interface UpdateGroupSyncProfileRequest {
    id?: string;
    profileName?: string | undefined;
    defaultDomain?: string | undefined;
    displayNameFormat?: string | undefined;
    mailNicknameFormat?: string | undefined;
    classCodeFormat?: string | undefined;
    descriptionFormat?: string | undefined;
    courseNumberFormat?: string | undefined;
    courseDescriptionFormat?: string | undefined;
    courseNameFormat?: string | undefined;
    courseSubjectFormat?: string | undefined;
    termNameFormat?: string | undefined;
    defaultAlternativeOwner?: string | undefined;
    hideFromAddresslist?: boolean | undefined;
    groupVisibility?: string | undefined;
    teamTemplate?: string | undefined;
    contentQuery?: string | undefined;
}

export interface EducationId {
    externalId?: string | undefined;
}

export interface EducationSchool extends EducationId {
    id?: string | undefined;
    description?: string | undefined;
    displayName?: string | undefined;
    externalSource?: string | undefined;
    phone?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
    address?: PhysicalAddress | undefined;
    createdBy?: IdentitySet | undefined;
}

export interface PhysicalAddress {
    city?: string | undefined;
    countryOrRegion?: string | undefined;
    postalCode?: string | undefined;
    state?: string | undefined;
    street?: string | undefined;
}

export interface IdentitySet {
    application?: Identity | undefined;
    device?: Identity | undefined;
    user?: Identity | undefined;
}

export interface Identity {
    displayName?: string | undefined;
    id?: string | undefined;
}

export interface AddOrUpdateSchoolRequest {
    description?: string | undefined;
    displayName?: string | undefined;
    externalId?: string | undefined;
    externalSource?: string | undefined;
    id?: string | undefined;
    phone?: string | undefined;
    principalEmail?: string | undefined;
    principalName?: string | undefined;
}

export interface Tenant extends BaseEntity {
    name?: string | undefined;
    activated?: boolean;
    createdByTenant?: string | undefined;
    createdByUser?: string | undefined;
    students?: number | undefined;
    teachers?: number | undefined;
    updateUsers?: boolean | undefined;
    updateGroupMembers?: boolean | undefined;
    adminConsentGranted?: boolean | undefined;
    matchingEnabled?: boolean | undefined;
    checkGroupsAfterScheduledSync?: boolean | undefined;
    updateUsersAfterScheduledSync?: boolean | undefined;
    userProfileExtensions?: boolean | undefined;
    userProfileFedLogin?: boolean | undefined;
}

export interface CreateTenantRequest {
    id?: string;
    name?: string | undefined;
    students?: number;
    teachers?: number;
    activated?: boolean;
    updateUsers?: boolean | undefined;
    updateGroupMembers?: boolean | undefined;
    matchingEnabled?: boolean | undefined;
    checkGroupsAfterScheduledSync?: boolean | undefined;
    updateUsersAfterScheduledSync?: boolean | undefined;
    userProfileExtensions?: boolean | undefined;
    userProfileFedLogin?: boolean | undefined;
}

export interface UpdateTenantRequest {
    id?: string;
    name?: string | undefined;
    students?: number;
    teachers?: number;
    activated?: boolean;
    updateUsers?: boolean | undefined;
    updateGroupMembers?: boolean | undefined;
    matchingEnabled?: boolean | undefined;
    checkGroupsAfterScheduledSync?: boolean | undefined;
    updateUsersAfterScheduledSync?: boolean | undefined;
    userProfileExtensions?: boolean | undefined;
    userProfileFedLogin?: boolean | undefined;
}

export interface TokenResponse {
    access_token?: string | undefined;
    token_type?: string | undefined;
    expires_in?: number;
    refresh_token?: string | undefined;
    scope?: string | undefined;
}

export interface TokenRequest {
    clientId?: string | undefined;
    clientSecret?: string | undefined;
    grantType?: string | undefined;
}

export interface SourceUser extends BaseEntity {
    source?: string | undefined;
    prefix?: string | undefined;
    externalId?: string | undefined;
    emailadres?: string | undefined;
    displayName?: string | undefined;
    initials?: string | undefined;
    givenname?: string | undefined;
    surnamePrefix?: string | undefined;
    surname?: string | undefined;
    privateEmail?: string | undefined;
    privatePhone?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    school?: string | undefined;
    brin?: string | undefined;
    isStudent?: boolean | undefined;
    isTeacher?: boolean | undefined;
    isFaculty?: boolean | undefined;
    externalAccountId?: string | undefined;
    age?: number | undefined;
    period?: string | undefined;
    mainClass?: string | undefined;
    study?: string | undefined;
    year?: number | undefined;
    location?: string | undefined;
    locationId?: string | undefined;
    scheduleCode?: string | undefined;
    position?: string | undefined;
    positionId?: number | undefined;
    mainSubject?: string | undefined;
    mainSubjectCode?: string | undefined;
    lastUpdate?: Date | undefined;
    azureObjectId?: string | undefined;
    synced?: boolean | undefined;
    hasLicense?: boolean | undefined;
    unavailable?: boolean | undefined;
    syncDisbaled?: boolean | undefined;
    badge?: string | undefined;
    status?: string;
}

export enum UserKind {
    Unknown = "Unknown",
    Faculty = "Faculty",
    Teacher = "Teacher",
    Employee = "Employee",
    Student = "Student",
}

export interface MatchUserRequest {
    userId?: string | undefined;
    azureId?: string | undefined;
    override?: boolean;
    resetSync?: boolean | undefined;
}

export interface CreateOrUpdateUsersResponse {
    newUsers?: number;
    updatedUsers?: number;
}

export interface SyncUsersRequest {
    userIds?: string[] | undefined;
}

export interface BatchUsersRequest {
    userIds?: string[] | undefined;
    action?: BatchUserAction;
}

export enum BatchUserAction {
    CheckGroups = "CheckGroups",
    Disable = "Disable",
    Delete = "Delete",
}

export interface UserSyncProfile extends SyncProfile {
    userPrincipalNameFormat?: string | undefined;
    companyFormat?: string | undefined;
    departmentFormat?: string | undefined;
    jobtitleFormat?: string | undefined;
    officeFormat?: string | undefined;
    givenNameFormat?: string | undefined;
    surnameFormat?: string | undefined;
    usageLocation?: string | undefined;
    country?: string | undefined;
    matchKeySource?: string | undefined;
    matchKeyGraph?: string | undefined;
    licenseId?: string | undefined;
    extensionSet?: boolean | undefined;
    extension1?: string | undefined;
    extension2?: string | undefined;
    extension3?: string | undefined;
    extension4?: string | undefined;
    extension5?: string | undefined;
    extension6?: string | undefined;
    extension7?: string | undefined;
    extension8?: string | undefined;
    extension9?: string | undefined;
    extension10?: string | undefined;
    extension11?: string | undefined;
    extension12?: string | undefined;
    extension13?: string | undefined;
    extension14?: string | undefined;
    extension15?: string | undefined;
    brin?: string | undefined;
    tussenvoegsel?: string | undefined;
    initials?: string | undefined;
    affiliation?: string | undefined;
    eduPersonProfileId?: string | undefined;
    digiDeliveryId?: string | undefined;
    enableAgeGroup?: boolean | undefined;
    blockUsersWhenUnavailable?: boolean | undefined;
    setLifecycleProperties?: boolean | undefined;
    setPrivateEmailAuth?: boolean | undefined;
    setPrivatePhoneAuth?: boolean | undefined;
    overrideAuthentication?: boolean | undefined;
    extra1Field?: string | undefined;
    extra1Value?: string | undefined;
    extra2Field?: string | undefined;
    extra2Value?: string | undefined;
    extra3Field?: string | undefined;
    extra3Value?: string | undefined;
    extra4Field?: string | undefined;
    extra4Value?: string | undefined;
}

export interface CreateUserSyncProfileRequest {
    id?: string;
    profileName?: string | undefined;
    defaultDomain?: string | undefined;
    companyFormat?: string | undefined;
    country?: string | undefined;
    departmentFormat?: string | undefined;
    displayNameFormat?: string | undefined;
    givenNameFormat?: string | undefined;
    jobtitleFormat?: string | undefined;
    mailNicknameFormat?: string | undefined;
    officeFormat?: string | undefined;
    surnameFormat?: string | undefined;
    usageLocation?: string | undefined;
    userPrincipalNameFormat?: string | undefined;
    matchKeySource?: string | undefined;
    matchKeyGraph?: string | undefined;
    enableAgeGroup?: boolean;
    extension1?: string | undefined;
    extension2?: string | undefined;
    extension3?: string | undefined;
    extension4?: string | undefined;
    extension5?: string | undefined;
    extension6?: string | undefined;
    extension7?: string | undefined;
    extension8?: string | undefined;
    extension9?: string | undefined;
    extension10?: string | undefined;
    extension11?: string | undefined;
    extension12?: string | undefined;
    extension13?: string | undefined;
    extension14?: string | undefined;
    extension15?: string | undefined;
    brin?: string | undefined;
    tussenvoegsel?: string | undefined;
    initials?: string | undefined;
    affiliation?: string | undefined;
    eduPersonProfileId?: string | undefined;
    digiDeliveryId?: string | undefined;
    blockUsersWhenUnavailable?: boolean | undefined;
    setLifecycleProperties?: boolean;
    setPrivateEmailAuth?: boolean;
    setPrivatePhoneAuth?: boolean;
    overrideAuthentication?: boolean;
    extra1Field?: string | undefined;
    extra1Value?: string | undefined;
    extra2Field?: string | undefined;
    extra2Value?: string | undefined;
    extra3Field?: string | undefined;
    extra3Value?: string | undefined;
    extra4Field?: string | undefined;
    extra4Value?: string | undefined;
}

export interface UpdateUserSyncProfileRequest {
    id?: string;
    profileName?: string | undefined;
    defaultDomain?: string | undefined;
    companyFormat?: string | undefined;
    country?: string | undefined;
    departmentFormat?: string | undefined;
    displayNameFormat?: string | undefined;
    givenNameFormat?: string | undefined;
    jobtitleFormat?: string | undefined;
    mailNicknameFormat?: string | undefined;
    officeFormat?: string | undefined;
    surnameFormat?: string | undefined;
    usageLocation?: string | undefined;
    userPrincipalNameFormat?: string | undefined;
    matchKeySource?: string | undefined;
    matchKeyGraph?: string | undefined;
    enableAgeGroup?: boolean | undefined;
    extension1?: string | undefined;
    extension2?: string | undefined;
    extension3?: string | undefined;
    extension4?: string | undefined;
    extension5?: string | undefined;
    extension6?: string | undefined;
    extension7?: string | undefined;
    extension8?: string | undefined;
    extension9?: string | undefined;
    extension10?: string | undefined;
    extension11?: string | undefined;
    extension12?: string | undefined;
    extension13?: string | undefined;
    extension14?: string | undefined;
    extension15?: string | undefined;
    brin?: string | undefined;
    tussenvoegsel?: string | undefined;
    initials?: string | undefined;
    affiliation?: string | undefined;
    eduPersonProfileId?: string | undefined;
    digiDeliveryId?: string | undefined;
    blockUsersWhenUnavailable?: boolean | undefined;
    updateAllValues?: boolean;
    setLifecycleProperties?: boolean | undefined;
    setPrivateEmailAuth?: boolean | undefined;
    setPrivatePhoneAuth?: boolean | undefined;
    overrideAuthentication?: boolean | undefined;
    extra1Field?: string | undefined;
    extra1Value?: string | undefined;
    extra2Field?: string | undefined;
    extra2Value?: string | undefined;
    extra3Field?: string | undefined;
    extra3Value?: string | undefined;
    extra4Field?: string | undefined;
    extra4Value?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}